import { TeamsCapacityFilters } from 'types/store/teamsCapacity';

export const addIdsToArrayIfNotExists: (
  idsToAdd: string[],
  idsArray: string[]
) => string[] = (idsToAdd, idsArray) => {
  if (idsArray.length === 0) {
    return idsToAdd;
  }
  const idsSet = new Set(idsArray);
  idsToAdd.forEach((id) => idsSet.add(id));
  return Array.from(idsSet);
};

export const addIdToArrayIfNotExists: (
  idsArray: string[],
  newId: string
) => string[] = (idsArray, newId) => {
  if (idsArray.includes(newId)) {
    return idsArray;
  }
  return idsArray.concat(newId);
};

export const appendProjectFilterParams = (
  url: string,
  filters?: TeamsCapacityFilters
): string => {
  if (!filters) return url;
  const params = new URLSearchParams();
  if (filters.status?.length) {
    filters.status.forEach((s) => params.append('status[]', s));
  }
  if (filters.archivedProjects !== undefined) {
    params.append('isArchived', filters.archivedProjects ? 'true' : 'false');
  }
  const queryString = params.toString();
  if (!queryString) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${queryString}`;
};

export const appendMemberFilterParams = (
  url: string,
  filters?: TeamsCapacityFilters
): string => {
  if (!filters) return url;
  const params = new URLSearchParams();
  if (filters.deactivatedUsers !== undefined) {
    params.append('deactivated', filters.deactivatedUsers ? 'true' : 'false');
  }
  const queryString = params.toString();
  if (!queryString) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${queryString}`;
};
